const Matic = () => {
	return (
		<svg xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 32 32' fill='none'>
			<g clipPath='url(#clip0_366_9718)'>
				<path
					d='M16 32C24.8367 32 32 24.8367 32 16C32 7.16333 24.8367 0 16 0C7.16333 0 0 7.16333 0 16C0 24.8367 7.16333 32 16 32Z'
					fill='#8247E5'
				/>
				<path
					d='M16 0.5C24.5605 0.5 31.5 7.43948 31.5 16C31.5 24.5605 24.5605 31.5 16 31.5C7.43948 31.5 0.5 24.5605 0.5 16C0.5 7.43948 7.43948 0.5 16 0.5Z'
					stroke='white'
					strokeOpacity='0.2'
				/>
				<g clipPath='url(#clip1_366_9718)'>
					<path
						d='M21.1042 13.1761C20.7396 12.9731 20.2708 12.9731 19.8542 13.1761L16.9375 14.8507L14.9583 15.9164L12.0937 17.591C11.7292 17.794 11.2604 17.794 10.8438 17.591L8.60417 16.2716C8.23958 16.0686 7.97917 15.6627 7.97917 15.2059V12.6686C7.97917 12.2627 8.1875 11.8567 8.60417 11.603L10.8438 10.3343C11.2083 10.1313 11.6771 10.1313 12.0937 10.3343L14.3333 11.6537C14.6979 11.8567 14.9583 12.2627 14.9583 12.7194V14.394L16.9375 13.2776V11.5522C16.9375 11.1462 16.7292 10.7403 16.3125 10.4865L12.1458 8.10146C11.7812 7.89847 11.3125 7.89847 10.8958 8.10146L6.625 10.5373C6.20833 10.7403 6 11.1462 6 11.5522V16.3224C6 16.7283 6.20833 17.1343 6.625 17.388L10.8438 19.7731C11.2083 19.9761 11.6771 19.9761 12.0937 19.7731L14.9583 18.1492L16.9375 17.0328L19.8021 15.4089C20.1667 15.2059 20.6354 15.2059 21.0521 15.4089L23.2917 16.6776C23.6562 16.8806 23.9167 17.2865 23.9167 17.7432V20.2806C23.9167 20.6865 23.7083 21.0925 23.2917 21.3462L21.1042 22.6149C20.7396 22.8179 20.2708 22.8179 19.8542 22.6149L17.6146 21.3462C17.25 21.1432 16.9896 20.7373 16.9896 20.2806V18.6567L15.0104 19.7731V21.4477C15.0104 21.8537 15.2188 22.2597 15.6354 22.5134L19.8542 24.8985C20.2188 25.1015 20.6875 25.1015 21.1042 24.8985L25.3229 22.5134C25.6875 22.3104 25.9479 21.9044 25.9479 21.4477V16.6268C25.9479 16.2209 25.7396 15.8149 25.3229 15.5612L21.1042 13.1761Z'
						fill='white'
					/>
				</g>
			</g>
			<defs>
				<clipPath id='clip0_366_9718'>
					<rect width='32' height='32' fill='white' />
				</clipPath>
				<clipPath id='clip1_366_9718'>
					<rect width='20' height='17' fill='white' transform='translate(6 8)' />
				</clipPath>
			</defs>
		</svg>
	);
};

export default Matic;
